import { render } from "./ChatFeedbackInput.vue?vue&type=template&id=35bf6414"
import script from "./ChatFeedbackInput.vue?vue&type=script&lang=js"
export * from "./ChatFeedbackInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__